export enum ListActionTypes {
  GetListsLocal = 'GetListsLocal',
  SetLists = 'SetLists',
}
